<template>
  <div class="display">
    <div class="f-tar">
      <Button @click="$router.push('/host/index/audit/list')">返回</Button>
    </div>
    <div v-if="info">
      <div class="item">
        <div class="item-l">提交时间：</div>
        <div class="item-r">{{ info.changeTime | moment("YYYY/MM/DD HH:mm:ss")}}</div>
      </div>
      <div class="item">
        <div class="item-l">审核状态：</div>
        <div class="item-r">
          <span v-if="info.status === 0" style="color: red;">尚未审核</span>
          <span v-if="info.status === 1" style="color: blue;">审核通过</span>
          <span v-if="info.status === -1" style="color: red;">审核未通过</span>
        </div>
      </div>
      <div class="item">
        <div class="item-l">公司名称：</div>
        <div
          class="item-r"
          :class="{editMode:  (info.original && info.original.compName !== info.compName)}"
        >{{ info.compName || 'N/A'}}</div>
      </div>
      <div class="item">
        <div class="item-l">公司英文名：</div>
        <div
          class="item-r"
          :class="{editMode:  (info.original && info.original.compNameEn !== info.compNameEn)}"
        >{{ info.compNameEn || 'N/A'}}</div>
      </div>
      <div class="item">
        <div class="item-l">国家/地区：</div>
        <div
          class="item-r"
          :class="{editMode:  (info.original && info.original.area !== info.area)}"
        >{{info.area || 'N/A'}}</div>
      </div>
      <div class="item">
        <div class="item-l">地址：</div>
        <div
          class="item-r"
          :class="{editMode:  (info.original && info.original.address !== info.address)}"
        >{{info.address || 'N/A'}}</div>
      </div>
      <div class="item">
        <div class="item-l">邮政编码：</div>
        <div
          class="item-r"
          :class="{editMode:  (info.original && info.original.postcode !== info.postcode)}"
        >{{info.postcode || 'N/A'}}</div>
      </div>
      <div class="item">
        <div class="item-l">英文地址：</div>
        <div
          class="item-r"
          :class="{editMode:  (info.original && info.original.addressEn !== info.addressEn)}"
        >{{info.addressEn || 'N/A'}}</div>
      </div>
      <!-- <div class="item">
        <div class="item-l">企业类型：</div>
        <div
          class="item-r"
          :class="{editMode:  (info.original && info.original.industry !== info.industry)}"
        >{{info.industry || 'N/A'}}</div>
      </div>
      <div class="item">
        <div class="item-l">人员规模：</div>
        <div
          class="item-r"
          :class="{editMode:  (info.original && info.original.scale !== info.scale)}"
        >{{info.scale || 'N/A'}}</div>
      </div>
      <div class="item">
        <div class="item-l">年销售额：</div>
        <div
          class="item-r"
          :class="{editMode:  (info.original && info.original.annualSales !== info.annualSales)}"
        >{{info.annualSales || 'N/A'}}</div>
      </div> -->
      <div class="item">
        <div class="item-l">公司网址：</div>
        <div
          class="item-r"
          :class="{editMode:  (info.original && info.original.website !== info.website)}"
        >{{info.website || 'N/A'}}</div>
      </div>
      <div class="item">
        <div class="item-l">公司邮箱：</div>
        <div
          class="item-r"
          :class="{editMode:  (info.original && info.original.email !== info.email)}"
        >{{info.email || 'N/A'}}</div>
      </div>
      <div class="item">
        <div class="item-l">联系人姓名：</div>
        <div
          class="item-r"
          :class="{editMode:  (info.original && info.original.linkFirstName !== info.linkFirstName)}"
        >{{info.linkFirstName}}{{info.linkLastName}}</div>
      </div>
      <div class="item">
        <div class="item-l">联系人手机：</div>
        <div
          class="item-r"
          :class="{editMode:  (info.original && info.original.linkMob !== info.linkMob)}"
        >{{info.linkMob || 'N/A'}}</div>
      </div>
      <div class="item">
        <div class="item-l">电话：</div>
        <div
          class="item-r"
          :class="{editMode:  (info.original && info.original.linkTel !== info.linkTel)}"
        >{{info.linkTel || 'N/A'}}</div>
      </div>
      <div class="item" v-if="false">
        <div class="item-l">传真：</div>
        <div
          class="item-r"
          :class="{editMode:  (info.original && info.original.linkFax !== info.linkFax)}"
        >{{info.linkFax || 'N/A'}}</div>
      </div>
      <div class="item" v-if="false">
        <div class="item-l">会刊中文简介：</div>
        <div
          class="item-r"
          :class="{editMode:  (info.original && info.original.introduction !== info.introduction)}"
        >{{info.introduction || 'N/A'}}</div>
      </div>
      <div class="item" v-if="false">
        <div class="item-l">会刊英文简介：</div>
        <div
          class="item-r"
          :class="{editMode:  (info.original && info.original.introductionEn !== info.introductionEn)}"
        >{{info.introductionEn || 'N/A'}}</div>
      </div>
      <div class="item" v-if="false">
        <div class="item-l">中文公司简介及产品简介：</div>
        <div
          class="item-r"
          :class="{editMode:  (info.original && info.original.profile !== info.profile)}"
        >{{info.profile || 'N/A'}}</div>
      </div>
      <div class="item" v-if="false">
        <div class="item-l">英文公司简介及产品简介：</div>
        <div
          class="item-r"
          :class="{editMode:  (info.original && info.original.profileEn !== info.profileEn)}"
        >{{info.profileEn || 'N/A'}}</div>
      </div> 

      <div class="item">
        <div class="item-l">Logo：</div>

        <div class="item-r">
          <div v-if="info.logo" class="logo-example">
            <div
              class="my-upload-list"
              style="width: 150px;height: 150px;line-height:150px;border: 1px solid #bfbfbf;"
              :class="{editMode:  (info.original && info.original.dlogo !== info.logo)}"
            >
              <img :src="info.logo" style="width: 150px;height: 150px;" />
            </div>
            <div class="logo-example-box">
              <div class="logo-example-item z-large-s">
                <img :src="info.logo" />
                <p>图片尺寸：200*200px</p>
              </div>
              <div class="logo-example-item z-large-m">
                <img :src="info.logo" />
                <p>图片尺寸：120*120px</p>
              </div>
              <div class="logo-example-item z-large-l">
                <img :src="info.logo" />
                <p>图片尺寸：30*30px</p>
              </div>
            </div>
          </div>
          <div v-else>N/A</div>
        </div>
      </div>
    </div>
    <div class="f-tac" v-if="info && info.status !== 1">
      <Button @click="pass" style="margin: 0 10px;" type="primary">通过审核</Button>
      <Button @click="unpass" style="margin: 0 10px;" type="primary">不通过</Button>
    </div>
    <div class="f-tac" v-if="info && (info.status === 1 && info.syncStatus === 2)">
      <Button @click="asyncHandle">重新同步</Button>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "host-audit-info-periodical",
  data() {
    return {
      query: null,
      info: null
    };
  },
  created() {
    this.query = this.$route.query;
    this.init();
  },
  computed: {
    cityBool() {
      let bool = false;
      if (this.info && this.info.original) {
        const cityStr = this.info.province + this.info.city + this.info.county;
        const cityStr2 =
          this.info.original.province +
          this.info.original.city +
          this.info.original.county;
        if (cityStr !== cityStr2) {
          bool = true;
        }
      }
      return bool;
    }
  },
  methods: {
    ...mapActions({
      getCatalogueDownByRecord: "hostAuditModule/getCatalogueDownByRecord",
      editCatalogueAudit: "hostAuditModule/editCatalogueAudit",
      reSync: "hostAuditModule/reSync"
    }),
    async init() {
      this.info = await this.getCatalogueDownByRecord(this.$route.query.id);
      
    },
    async pass() {
      // 通过审核

      const opt = {
        id:this.$route.query.id,
        opt:{
        id: this.info.recordId,
        status: 1,
        joinId: this.$route.query.id
      }
      };
      const bool = await this.editCatalogueAudit(opt);
      if (bool && bool.successed) {
        this.$Message.success("操作成功");
        // this.$router.push("/host/index/audit/list");
        this.init();
      } else {
        if (bool.errors.description) {
          this.$Message.error(bool.errors.description);
        } else {
          this.$Message.error("操作失败，请重新尝试");
        }
      }
    },
    async unpass() {
      // 不通过审核
      const opt = {
        id:this.$route.query.id,
        opt:{
            id: this.info.recordId,
            status: -1,
        joinId: this.$route.query.id

        }
      }
      const bool = await this.editCatalogueAudit(opt);
      if (bool && bool.successed) {
        this.$Message.success("操作成功");
        // this.$router.push("/host/index/audit/list");
        this.init();
      } else {
        if (bool.errors.description) {
          this.$Message.error(bool.errors.description);
        } else {
          this.$Message.error("操作失败，请重新尝试");
        }
      }
    },
    async asyncHandle() {
      // 重新同步 
      const bool = await this.reSync({exchangeId: this.info.exchangeId});
      if (bool && bool.successed) {
        this.$Message.success("操作成功"); 
        this.init();
      } else {
        if (bool.errors.description) {
          this.$Message.error(bool.errors.description);
        } else {
          this.$Message.error("操作失败，请重新尝试");
        }
      }
    }
  }
};
</script>

<style scoped lang="scss">
.display {
  padding: 20px 40px 40px;
  font-size: 14px;
  background: #fff;
  margin: 30px;
  color: #333;
  min-width: 800px;
  mim-height: 500px;
  .item {
    display: flex;
    margin-bottom: 18px;
    &-l {
      width: 200px;
      text-align: right;
    }
    &-r {
      flex: 1;
    }
  }
}
.logo-example {
  display: flex;
  &-box {
    display: flex;
    flex-wrap: wrap;
    flex: 1;
  }
  &-item {
    display: flex;
    width: 100%;
    p {
      font-size: 12px;
      color: #808080;
      padding-left: 10px;
    }
    &.z-large-s {
      img {
        width: 40px;
        height: 40px;
        border: 1px solid #bfbfbf;
      }
      p {
        line-height: 40px;
      }
    }
    &.z-large-m {
      img {
        width: 30px;
        height: 30px;
        border: 1px solid #bfbfbf;
      }
      p {
        line-height: 30px;
      }
    }
    &.z-large-l {
      img {
        width: 20px;
        height: 20px;
        border: 1px solid #bfbfbf;
      }
      p {
        line-height: 20px;
      }
    }
  }
}
.editMode {
  color: red !important;
}
.edit {
  border-color: red !important;
}
</style>
